import { render, staticRenderFns } from "./EnergyStructure.vue?vue&type=template&id=45f2249e&scoped=true&"
import script from "./EnergyStructure.vue?vue&type=script&lang=js&"
export * from "./EnergyStructure.vue?vue&type=script&lang=js&"
import style0 from "./EnergyStructure.vue?vue&type=style&index=0&id=45f2249e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f2249e",
  null
  
)

export default component.exports